var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.91,
    height: 12,
    viewBox: "0 0 10.91 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "home-2",
    "data-name": "home",
    d: "M2.211,4.934A.544.544,0,0,0,2,5.364v6A1.637,1.637,0,0,0,3.636,13h7.637a1.637,1.637,0,0,0,1.636-1.636v-6a.545.545,0,0,0-.211-.43L7.79,1.116a.547.547,0,0,0-.67,0ZM9.637,11.91V7a.546.546,0,0,0-.545-.545H5.818A.546.546,0,0,0,5.273,7V11.91H3.636a.546.546,0,0,1-.545-.545V5.631L7.455,2.237l4.364,3.394v5.734a.546.546,0,0,1-.545.545Zm-3.273,0V7.546H8.546V11.91Z",
    transform: "translate(-2 -1.001)",
    fill: "#05152d"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.ca0851e5a19f0af5ed69547db85ac04a.svg";
export { ForwardRef as ReactComponent };